import { Injectable } from '@angular/core';
import { ICvxClaimsPrincipal } from '@cvx/cal';
import { CalAngularService } from '@cvx/cal-angular';
import { BehaviorSubject, lastValueFrom, map, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthenticationResult } from '@azure/msal-common';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../services/common.service';

@Injectable({
  providedIn: 'root',
})
export class CalService {

  private cal: CalAngularService;

  private userSubject: BehaviorSubject<ICvxClaimsPrincipal> = new BehaviorSubject({} as ICvxClaimsPrincipal);
  private isLoggedInSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  clientId: string = environment.calSettings.clientId

  constructor(authService: CalAngularService, private router: Router, private commonService: CommonService) {
    this.cal = authService;
  }

  isUserLoggedIn(): Observable<boolean> {
    return this.isLoggedInSubject.asObservable();
  }

  getUserInfo(): Observable<ICvxClaimsPrincipal> {
    return this.userSubject.asObservable();
  }

  public getFirstName() {
    return this.userSubject.pipe(map((user: any) => {
      sessionStorage.setItem('currentUser', user.userName);
      if (user.name) {
        // return user.name.split(',')[1].split('[')[0];
        return user._name;
      }
      return '';
    }));
  }

  public getNamePart() {
    return this.userSubject.pipe(map((user:any) => {
      if (user?.name) {
        return user?.userName?.split('@')[0];
      }
      return '';
    }));
  }

  private getUserRoles(): string[] {
    // let roles: string[] = [];
    // const data = localStorage.getItem("cachedCvxClaimsPrincipal");
    // if (data === null) {
    //   return [];
    // }
    // else {
    //   const principal = JSON.parse(data);
    //   roles = principal._roles;
    // }
    //
    // return roles;

    return this.cal.cvxClaimsPrincipal.roles;
  }

  async getAADToken(
    oidcScopes: string[] = environment.calSettings.apiScopes,
    fullAuthResponse: boolean = false)
    : Promise<string | AuthenticationResult | null> {
    return lastValueFrom(this.cal.getAADToken(oidcScopes, fullAuthResponse));
  }

  async getPowerBiAADToken(
    oidcScopes: string[] = environment.powerBi.powerBiScopes,
    fullAuthResponse: boolean = false)
    : Promise<string | AuthenticationResult | null> {
    return lastValueFrom(this.cal.getAADToken(oidcScopes, fullAuthResponse));
  }

  async updateAccessToken(): Promise<string> {

    const graphScopes: any = environment.calSettings.graphScopes.slice(0);

    graphScopes.unshift(`${environment.calSettings.clientId}/user_impersonation`);

    const token: Promise<string> = this.getAADToken(graphScopes, false) as Promise<string>;

    return token;
  }

  public signIn(): Promise<boolean> {
    // get Microsoft access token
    return lastValueFrom(this.cal.userInitiatedSignIn()).then(async (data: any) => {
      this.userSubject.next(data);
      this.isLoggedInSubject.next(data != null);
      this.commonService.updateCurrentuser({ userName: data._userName, name: data._name, isUser: data._isUser });
      // update the token to be able to reach out to the backend
      await this.updateAccessToken();

      if (!data) {
        console.error('User failed to log in.');
      }

      return data != null;
    });
  }

  // logout the user
  public signOut(): void {
    this.cal.userInitiatedSignOut();
  }
}
